<template>
  <b-row class="about" v-if="data != null">
    <b-col cols="12" lg="6">
      <img class="img" :src="data.img.url" alt />
    </b-col>
    <b-col cols="12" lg="6">
      <wysiwyg-component v-html="data.wysiwyg"></wysiwyg-component>
      <router-link class="about-readme" :to="data.aboutlink.replace('/api', '')" tag="a">Читать далее >></router-link>

      <!-- <div class="about-link-container">
        <img src="@/assets/img/decorative.png" class="decorative" alt />
        <div class="about-link-container-inner">
          <div class="content">
            <h3 class="ttl">
              Вы можете ознакомиться
              с нашей презентацией
            </h3>
            <div class="d-flex flex-column flex-md-row justify-content-start align-items-center">
              <a
                :href="data.file.url"
                class="link1 d-flex justify-content-center align-items-center"
                download
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.54166 13.4583H13.4583C13.6462 13.4583 13.8264 13.5329 13.9592 13.6658C14.092 13.7986 14.1667 13.9788 14.1667 14.1666C14.1667 14.3545 14.092 14.5347 13.9592 14.6675C13.8264 14.8003 13.6462 14.875 13.4583 14.875H3.54166C3.3538 14.875 3.17363 14.8003 3.04079 14.6675C2.90796 14.5347 2.83333 14.3545 2.83333 14.1666C2.83333 13.9788 2.90796 13.7986 3.04079 13.6658C3.17363 13.5329 3.3538 13.4583 3.54166 13.4583ZM9.20833 9.33225L11.5055 7.03583L12.507 8.03742L8.49999 12.0445L4.49295 8.03742L5.49454 7.03583L7.79166 9.33225V1.41663H9.20833V9.33225Z"
                    fill="white"
                  />
                </svg>
                Скачать
              </a>
              <a
                :href="data.file.url"
                class="link2 d-flex justify-content-center align-items-center"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                >
                  <path
                    d="M1.66666 7.00008C1.66666 7.00008 4.33332 1.66675 8.99999 1.66675C13.6667 1.66675 16.3333 7.00008 16.3333 7.00008C16.3333 7.00008 13.6667 12.3334 8.99999 12.3334C4.33332 12.3334 1.66666 7.00008 1.66666 7.00008Z"
                    stroke="#B33031"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 9.00012C10.1046 9.00012 11 8.10469 11 7.00012C11 5.89555 10.1046 5.00012 9 5.00012C7.89543 5.00012 7 5.89555 7 7.00012C7 8.10469 7.89543 9.00012 9 9.00012Z"
                    stroke="#B33031"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Просмотреть
              </a>
            </div>
          </div>
        </div>
      </div>-->
    </b-col>
  </b-row>
</template>

<script>
const axios = require("axios");
export default {
  data() {
    return {
      data: null
    };
  },
  created() {
    axios
      .get(`${this.$root.routLink}${this.$route.path}?ajax&act=about`, {
        responseType: "json"
      })
      .then(({ data }) => {
        this.data = JSON.parse(data.addons).about;
      });
  }
};
</script>

<style lang="scss" scoped>
.about {
  .img {
    width: 100%;
    max-width: 100%;
    @media only screen and (max-width: $md),
      only screen and (max-device-width: $md) {
      margin-bottom: 30px;
    }
  }
  &-readme {
    text-decoration: none;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 180.1%;
    color: $secondFontColor;
    transition: all 300ms ease-in-out;
    margin-bottom: 24px;
    display: block;

    &:hover {
      color: $activeColor;
    }
  }

  // &-link-container {
  //   background: #ffffff;
  //   box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.05);
  //   border-radius: 6px;
  //   padding: 10px;
  //   position: relative;
  //   .decorative {
  //     background: #ebdada;
  //     box-shadow: 0px 4px 24px rgba(179, 48, 49, 0.25);
  //     border-radius: 6px;
  //     position: absolute;
  //     right: -20px;
  //     top: 50%;
  //     transform: translateY(-50%);
  //     @media only screen and (min-width: $lg),
  //       only screen and (min-device-width: $lg) {
  //       top: 5%;
  //     }
  //     @media only screen and (max-width: $md),
  //       only screen and (max-device-width: $md) {
  //       top: 25px;
  //       right: -10%;
  //       transform: translateX(-50%);
  //     }
  //     @media only screen and (max-width: $sm),
  //       only screen and (max-device-width: $sm) {
  //       top: 8%;
  //       right: 50%;
  //       transform: translateX(50%);
  //     }
  //   }

  //   &-inner {
  //     background: #ffffff;
  //     border: 1px solid #f0ecec;
  //     box-sizing: border-box;
  //     border-radius: 6px;
  //     padding: 20px 15px 32px 15px;
  //     @media only screen and (max-width: $sm),
  //       only screen and (max-device-width: $sm) {
  //       padding: 120px 15px 15px 15px;
  //     }

  //     .content {
  //       .ttl {
  //         font-weight: 500;
  //         font-size: 22px;
  //         line-height: 110.1%;
  //         color: #2e2e2e;
  //         margin-bottom: 12px;
  //         @media only screen and (max-width: $sm),
  //           only screen and (max-device-width: $sm) {
  //           text-align: center;
  //           font-size: 18px;
  //           margin-bottom: 25px;
  //         }
  //       }
  //       .link1 {
  //         background: $activeColor;
  //         box-shadow: 0px 0px 44px rgba(179, 48, 49, 0.25);
  //         border-radius: 6px;
  //         width: 165px;
  //         height: 40px;
  //         font-weight: 700;
  //         font-size: 14px;
  //         line-height: 18px;
  //         color: #ffffff;
  //         transition: all 0.3s ease-in-out;
  //         margin-right: 20px;
  //         @media only screen and (max-width: $sm),
  //           only screen and (max-device-width: $sm) {
  //           margin-right: 0;
  //           margin-bottom: 15px;
  //         }
  //         svg {
  //           margin-right: 12px;
  //           path {
  //             transition: all 0.3s ease-in-out;
  //           }
  //         }
  //         &:hover {
  //           background: #ffffff;
  //           color: $activeColor;
  //           border: 1px solid $activeColor;
  //           svg {
  //             path {
  //               fill: $activeColor;
  //             }
  //           }
  //         }
  //       }
  //       .link2 {
  //         border: 1px solid $activeColor;
  //         box-sizing: border-box;
  //         box-shadow: 0px 0px 14px rgba(179, 48, 49, 0.55);
  //         border-radius: 6px;
  //         width: 165px;
  //         height: 40px;
  //         font-weight: 700;
  //         font-size: 14px;
  //         line-height: 18px;
  //         color: $activeColor;
  //         transition: all 0.3s ease-in-out;
  //         svg {
  //           margin-right: 12px;
  //           path {
  //             transition: all 0.3s ease-in-out;
  //           }
  //         }
  //         &:hover {
  //           border: 1px solid $activeColor;
  //           color: #ffffff;
  //           background-color: $activeColor;
  //           svg {
  //             path {
  //               stroke: #ffffff;
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>

